import { useQuery } from '@tanstack/react-query';

import { Service } from '@/infra/services/action-plan';
import { QUERY_KEYS } from '@/utils/query-keys';

interface GetActionPlansByReportParams {
	company_id: string;
	organization_id: string;
	sera_summary_review_id?: string;
	file_id: string;
	custom_report_step_key_id?: string;
	custom_report_sub_step_key_id?: string;
}

export const useGetActionPlansByReport = (params: GetActionPlansByReportParams) => {
	return useQuery({
		queryKey: [QUERY_KEYS.GET_ACTION_PLANS_BY_REPORT, params],
		queryFn: async () => Service.findAllByReport(params),
		enabled: !!params.organization_id && !!params.company_id
	});
};
